export default __webpack_public_path__ + "static/media/sico_canopy_sunrise.04bfc755.jpg";